<template>
  <div id="exam-manage-modal-parent">
    <Page title="受検画面管理" helpInfoTitle="アセスメントサーベイ受検画面に関する設定を編集できます">
      <template v-slot:content
        ><div class="uk-margin-medium-left uk-margin-medium-top">
          <label class="uk-text-bold uk-margin-small-right">アセスメントサーベイ受検結果の閲覧範囲について編集</label
          ><HelpIcon
            tooltipText="アセスメントサーベイ受検画面に表示する受検結果の閲覧範囲及び問い合わせ先を編集できます"
            position="top-left"
            cls="uk-active uk-width-auto"
          />
          <ActionButton class="uk-margin-small-left" title="日本語" color="primary" @click="openModal('ja')" />
          <ActionButton class="uk-margin-small-left" title="英語" color="primary" @click="openModal('en')" /></div
      ></template>
    </Page>
    <div class="uk-flex-top position-form-modal" uk-modal ref="modal" container="#exam-manage-modal-parent" :bg-close="false">
      <PrivacyPolicyForm :key="formKey" @submit="onSubmitted" :privacyPolicy="formData" :lang="lang" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
@include table-action;
@include modal-form;
.main-content {
  margin-right: $spacing-medium;
}
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import Page from "../molecules/Page.vue";
import ActionButton from "../atoms/ActionButton.vue";
import Table from "../molecules/Table.vue";
import UIkit from "uikit";
import PrivacyPolicyForm from "../organisms/PrivacyPolicyForm.vue";
import SearchField from "../atoms/SearchField.vue";
import Store from "../../store";
import HelpIcon from "../atoms/HelpIcon.vue";
import { SystemApi, PrivacyPolicyResponse, LanguagesEnum } from "../../autogen";

@Options({
  components: {
    Page,
    ActionButton,
    Table,
    PrivacyPolicyForm,
    SearchField,
    HelpIcon
  }
})
export default class ExamManage extends Vue {
  private readonly storeInstance = Store.getInstance();
  @Ref("modal") modal!: HTMLElement;
  @Ref("form") form!: HTMLElement;
  formKey = 0;
  query = "";
  lang: keyof typeof LanguagesEnum = "ja";
  formData: PrivacyPolicyResponse = {};

  private async loadData(lang: keyof typeof LanguagesEnum) {
    const response = await new SystemApi().getPrivacyPolicy({
      language: lang
    });
    this.formData = response.data;
  }

  onSubmitted() {
    UIkit.modal(this.modal).hide();
  }
  async openModal(lang: keyof typeof LanguagesEnum) {
    this.formKey = Date.now();
    this.lang = lang;
    await this.loadData(lang);
    UIkit.modal(this.modal).show();
  }
}
</script>
